<template>
  <simple-table :data="data" :columns="columns" :stretch="false" :show-row-numbers="true" :auto-sort-column="3" auto-sort-reverse="true"/>
</template>

<script>
    import SimpleTable from "../simple-table/SimpleTable";
    export default {
      name: "LocaiteStatusConnectedDevices",
      components: {SimpleTable},
      props: ["data"],
      data: function() {
        return {
          columns: [{
            header: "DeviceID", field: "DeviceID"},
            {header: "Via", field:"GatewayPod"},
            {header: "Last Contact", field: "LastContact", format: "dateTime"},
            {header: "Last Contact", field: "LastContact", format: "diffFromNow"}
            ],
        }
      },
    }
</script>

<style scoped lang="less">

</style>
